import React, {Component} from 'react'
import {connect} from 'react-redux';

// Components
import Alert from 'react-s-alert';

//Components Material
import AppBar from "@material-ui/core/AppBar";
import { Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";

//Engage Components
import NDF from '../noDataFound';
import Loader from "../../components/Loader";
import { SweetConfirmationAlert} from '../../components/Alert/sweetAlert';

//Constants
import {currentPage,itemPerPage} from "../../constants/index";

//Views
import AddEditUser from '../users/AddEditUser';

//Action
import {GetAllUsers} from '../../actions/userAction'
import {SetHeaderButtons} from '../../actions/headerButtonsActions';

class User extends Component{
    constructor(props){
        super(props);

        this.state={
            open : false,
            currentPage: currentPage,
            itemPerPage: itemPerPage,
            userSelected: undefined,
            currentUser:'',
            isUpd:false

        }

    }

    componentDidMount(){
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        const profileKeyCloakObj = localStorage.getItem('ky')? JSON.parse(localStorage.getItem('ky')) : undefined;
        let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile)? profileKeyCloakObj.profile:  undefined;
        let currentUser = (profileObject && profileObject.username)?profileObject.username: undefined;
        this.setState({currentUser: currentUser});

        this.props.GetAllUsers();

        this.SetHeaderButtons();
    };

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this));
        this.props.SetHeaderButtons(undefined);
    };
    
    SetHeaderButtons = (open = false) =>{
        const headerButtons= this.getHeaderButtons(open);
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = (open = false) =>{
        const styles ={
            globalActions:{               
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }

        return(           
            <div style={styles.globalActions}>
            {
                !open ?
                <div className="appbtn-engage skybluebtn-engage appbtn-list-engage appbtnBarButton" onClick={this.handlerAdd} 
                   id='new_user_btn' style={styles.globalActions}
                >
                    New User
                </div> : 
                <div className="appbtn-list-engage" 
                style={styles.globalActions}>

                    {
                        (this.state.currentUser === 'superuser' && this.state.isUpd)?
                        <div id='confirm_user_btn' className="appbtn-engage purplebtn-engage appbtnBarButton" onClick={this.handlerConfirm}>
                            Confirm
                        </div>   
                        :
                        undefined
                    }
                    {
                        (this.state.isUpd===false)?
                        <div id='save_user_btn' className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.handlerSave}>
                        Save
                        </div> 
                        :
                        undefined
                    }
                    <div id='cancel_user_btn' className="appbtn-engage redbtn-engage appbtnBarButton" onClick={this.handlerCancel}>
                        Cancel
                    </div>                                                                                            
                </div> 
            }
        </div>
        )
    };


    resize() {
        this.setState({isMobile: window.innerWidth <= 960});
    };

    //Buttons Handlers
    handlerClose = (pageNextItem = 0) =>{
        this.setState({open: false, activitySelected:{}});
        this.SetHeaderButtons(false);
        this.props.GetAllUsers();

        if(pageNextItem > 0){
            this.handlePageChange(pageNextItem);
        }
    };

    handlerAdd = () =>{
        this.clearState();
        this.setState({open:true})
        this.SetHeaderButtons(true);
    };
  
    async handleEdit(e, item){

        this.setState({open:true, userSelected:item, isUpd:true}, ()=> this.SetHeaderButtons(true));          

    };

    handlerConfirm=()=>{
        var link = document.getElementById('confirm_btn')
        link.click()
    }

    handleDelete = async (e,data,index)=>{
        const title= 'Are you sure you want to delete the User?';
          
        const {isConfirmed} = await  SweetConfirmationAlert(title,'alert_DeleteUser');

        if(isConfirmed){
            //this.deleteUser({},idDelete);
        }
    }


    deleteUser = ()=>{
        
        const lastPage = Math.ceil((this.props.tableData.length-1 )  / this.state.itemPerPage);
               
        if(this.state.currentPage > lastPage){
            this.handlePageChange(lastPage);
        }
 
         Alert.closeAll();
     };
 
       

    //Hace click en el boton de la pagina AddEditActivity
    handlerCancel = () =>{
        var link = document.getElementById('cancel_btn')
        link.click()
        this.clearState();
    };

    //Hace click en el boton de la pagina AddEditActivity
    handlerSave = () =>{
        var link = document.getElementById('save_btn')
        link.click();
    };

    clearState(){
        this.setState({
            open : false,
            currentPage: currentPage,
            itemPerPage: itemPerPage,
            userSelected: undefined,
            isUpd:false,
            //isMobile
            isMobile: false
        });
    };
    //#region  PAGINATION
    handlePageChange = (number)=> {

        if(number && typeof(number) == 'number' && number > 0){
            this.setState({
                currentPage: Number(number)
            });
        }
    
        };
    //#endregion

    setIdsPaginationHandler = () =>{
        try{
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if(pagContainer && pagContainer.length> 0 && pagContainer[0]){
                const pag = pagContainer[0];
                const liElements =pag.getElementsByTagName('li');
                if(liElements && liElements.length >= 4){
                    for(let i=0; i< liElements.length; i++){
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if(btn_GoToFist){
                        btn_GoToFist.setAttribute('id','pag_btn_gotofirst');
                        btn_GoToFist.click(() =>setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if(btn_back){
                        btn_back.setAttribute('id','pag_btn_goback');
                        btn_back.click(() =>setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length-2];
                    if(btn_forward){
                        btn_forward.setAttribute('id','pag_btn_goforward');
                        btn_forward.click(() =>setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length-1];
                    if(btn_GoToLast){
                        btn_GoToLast.setAttribute('id','pag_btn_gotolast');
                        btn_GoToLast.click(() =>setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for(let i = 2; i< liElements.length - 2; i++){
                        const btn = liElements[i].getElementsByTagName('button');
                        
                        if(btn && btn.length >0 && btn[0] && btn[0].textContent.length > 0){
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        }catch(err){}
    }

    
    render(){
        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);

        const disabledButton = true;

        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;
        const indexOfLastTodo = currentPage * itemPerPage;
        const indexOfFirstTodo = indexOfLastTodo - itemPerPage;
        
        const totalItems =this.props.tableData && this.props.tableData.length; 
        const lastPage =  Math.ceil(totalItems / itemPerPage);
        const pageNextItem = totalItems % itemPerPage === 0 ? lastPage+1 : lastPage ;
        
        
        const currentData = this.props.tableData && this.props.tableData.length > 0 ? this.props.tableData.slice(indexOfFirstTodo, indexOfLastTodo) : [];
        
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        const styles ={
            title:{
                flexGrow: 1
            },
            globalActions:{               
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledButton:{
                backgroundColor:'white'
            }
        }

        //ThumbnailImage
        // const ThumbnailImage = (
        //     {
        //         height = '55px',
        //         width = '90px',
        //         borderRadius='7px',
        //         alt,
        //         url
        //     }
        // ) =>{
        //     return(
        //         <img
        //             alt={'Thumbnail '+alt}
        //             style={{borderRadius:'9px'}}
        //             width={width}
        //             height={height}
        //             src={url}
        //         >
        //         </img>
        //     );
        // };

        return(
            <React.Fragment>
            <AppBar position="static" className="dark">
                <Toolbar>
                    <Typography variant="h6" className={styles.title}>
                        Users
                    </Typography>
                    {/* <div style={styles.globalActions}>
                        {
                            !this.state.open ?
                            <div className="appbtn-engage skybluebtn-engage appbtn-list-engage" onClick={this.handlerAdd} 
                            style={styles.globalActions}>
                                New User
                            </div> : 
                            <div className="appbtn-list-engage" 
                            style={styles.globalActions}>
                                <div className="appbtn-engage skybluebtn-engage" onClick={this.handlerSave}>
                                    Save
                                </div> 
                                <div className="appbtn-engage redbtn-engage" onClick={this.handlerCancel}>
                                    Cancel
                                </div>                                                                                            
                            </div> 
                        }
                    </div> */}
                </Toolbar>
            </AppBar>
              <main style={{flexGrow: '1', padding: '7px 20px',zIndex: '1300'}}>
                <div className="activityTitle-engage">
                    {
                        this.state.open ?
                       <AddEditUser 
                            closeDialog={this.handlerClose}
                            data={this.state.userSelected? this.state.userSelected: undefined }
                            newItemPage = {pageNextItem} 
                            currentPage= {currentPage}
                            itemPerPage = {itemPerPage}
                            currentUser={this.state.currentUser}
                        />
                        :
                        <Grid container >
                            {
                                <Loader isLoading={!this.props.tableData? 0:1} />
                            }
                            <Grid container style={{flexGrow:1, display:displayHeaders}} >
                                    <Grid item md={2}>User</Grid>
                                    <Grid item md={1}>Account type</Grid>
                                    <Grid item md={2}>First Name</Grid>
                                    <Grid item md={2}>Last Name</Grid>                                
                                    <Grid item md={2}>Community</Grid> 
                                    <Grid item md={2}>Status</Grid> 
                                    <Grid item md={1}></Grid>
                                    
                            </Grid>
                            <Grid container  >
                                {
                                    currentData.map((item, index) => {
                                       

                                        return(
                                            <Grid id={`user_row_${item._id}`} container key={index} alignItems='center' style={{backgroundColor:'#1f1f1f', padding:'5px', borderRadius:'4px', marginTop:'6px', cursor:'pointer'}}  onClick={(e) => {this.handleEdit(e,item);}}>
                                                <Grid item xs={12} sm={12} md={2} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{item.userName}</Grid>
                                                <Grid item xs={12} sm={12} md={1} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{(item.superUser===true)?'SuperUser':'User'}</Grid>
                                                <Grid item xs={12} sm={12} md={2} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{item.firstName}</Grid>                                
                                                <Grid item xs={12} sm={12} md={2} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{item.lastName}</Grid>
                                                <Grid item xs={12} sm={12} md={2} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{(item.communityName)?item.communityName:'NA'}</Grid> 
                                                <Grid item xs={12} sm={12} md={2} style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{item.userStatus?item.userStatus:'complete'}</Grid> 
                                                {/* <Grid item xs={12} sm={12} md={1} 
                                                    className='EngageButonClass' 
                                                    style={{alignContent:'center',display:'flex', justifyContent:'center'}}
                                                >
                                                    <Button
                                                    variant="contained"
                                                    value={item._id}
                                                    color='secondary'
                                                    onClick={(e) => {
                                                        this.handleEdit(e,item);
                                                    }}>
                                                        <EditIcon  />
                                                    </Button>
                                                </Grid> */}
                                                <Grid item xs={12} sm={12} md={1} 
                                                    className='EngageButonClass' 
                                                    style={{alignContent:'center', display:'flex', justifyContent:'center'}}
                                                >
                                                    <Button
                                                    id={`user_delete_btn${item._id}`}
                                                    variant="contained"
                                                    value={item._id}
                                                    style={disabledButton ? styles.disabledButton: {}}
                                                    disabled={disabledButton}
                                                    color='secondary'
                                                    onClick={(e) => {
                                                        this.handleDelete(e,item);
                                                    }}>
                                                        <DeleteIcon  />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )})   
                                }
                            </Grid>
                            <div style={{marginLeft:'auto', marginRight:'0'}} >
                                    <Grid item xs={12} >
                                    {
                                    currentData && currentData.length ? 
                                        <Pagination
                                            count ={Math.ceil(totalItems / itemPerPage) }
                                            defaultPage= {1}
                                            onChange = {(e, item) => { this.handlePageChange(item)}}
                                            page= {currentPage}
                                            showFirstButton 
                                            showLastButton
                                            siblingCount={1}
                                            boundaryCount= {1}
                                        />
                                    :
                                        <NDF/>
                                    }
                                    </Grid>
                                </div>
                        </Grid>
                    }
                </div>
              </main>
        </React.Fragment>
        );
    }
};


function mapStateToProps(state){
    const userData = (state.userReducer && state.userReducer.userData)?  state.userReducer.userData : undefined;

    return {
        tableData: userData
    }
};

export default connect(mapStateToProps, {GetAllUsers, SetHeaderButtons})(User )